export const getKeysTotal = (obj) => {
    return Object.keys(obj).reduce((s, t) => s + obj[t], 0);
};

//TODO 这里谁处理一下，业务不能写到 utils里。
export const getAllMembers = (nexus) => {
    let total = 0;
    if (nexus.countFans) total = (nexus.retail ? nexus.retail.son : 0) + (nexus.team ? nexus.team.sons : 0) + nexus.countFans;
    else total = (nexus.retail ? nexus.retail.son : 0) + (nexus.team ? nexus.team.sons : 0)
    return total;
};
export const timestampToTime = (timestamp) => {
    const date = new Date(timestamp * 1000);
    return (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/' + date.getDate() + ' ';
};
// 时/天/周/月/年
function addzoro(m) { return m < 10 ? '0' + m : m; }
export const dateFormat = (timestamp) => {
    const time = new Date(timestamp);
    const y = time.getFullYear();
    const m = time.getMonth() + 1;
    const d = time.getDate();
    return y + '-' + addzoro(m) + '-' + addzoro(d);
};
export const formate = (timestamp) => {
    const time = new Date(timestamp);
    const y = time.getFullYear();
    const m = time.getMonth() + 1;
    const d = time.getDate();
    const h = time.getHours();
    const mm = time.getMinutes();
    const s = time.getSeconds();
    return y + '-' + addzoro(m) + '-' + addzoro(d) + '  ' + addzoro(h) + ':' + addzoro(mm) + ':' + addzoro(s);
};
// 日时分秒
export const formateDay = (timestamp) => {
    const time = new Date(timestamp);
    const y = time.getFullYear();
    const m = time.getMonth() + 1;
    const d = time.getDate();
    const h = time.getHours();
    const mm = time.getMinutes();
    const s = time.getSeconds();
    return addzoro(m) + '-' + addzoro(d) + '  ' + addzoro(h) + ':' + addzoro(mm);
};
// 月 日
export const formateMonth = (timestamp) => {
    const time = new Date(timestamp);
    const m = time.getMonth() + 1;
    const d = time.getDate();
    return addzoro(m) + '/' + addzoro(d);
};
// 时分秒
export const TimeFormat = (timestamp) => {
    const time = new Date(timestamp);
    const h = time.getHours();
    const mm = time.getMinutes();
    const s = time.getSeconds();
    return addzoro(h) + ':' + addzoro(mm) + ':' + addzoro(s);
};

function prefixIntegerZore(num, length) {
 return (Array(length).join('0') + num).slice(-length);
}

export const formatDate = (format,date)=> {
    date = date||new Date();
    var o = {
    "M+" : date.getMonth()+1, //month
    "d+" : date.getDate(), //day
    "H+" : date.getHours(), //hour
    "m+" : date.getMinutes(), //minute
    "s+" : date.getSeconds(), //second
    "q+" : Math.floor((date.getMonth()+3)/3), //quarter
    "S" : prefixIntegerZore(date.getTime()%1000,3) //millisecond
    }
    if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
    (date.getFullYear()+"").substr(4- RegExp.$1.length));
    for(var k in o)if(new RegExp("("+ k +")").test(format))
    format = format.replace(RegExp.$1,
    RegExp.$1.length==1? o[k] :
    ("00"+ o[k]).substr((""+ o[k]).length));
    return format;
}

export const getQueryString = (strName) => {
    var strHref = document.location.toString();
    var intPos = strHref.indexOf('?');
    var strRight = strHref.substr(intPos + 1);
    var arrTmp = strRight.split('&');

    for (var i = 0; i < arrTmp.length; i++) {
        var dIntPos = arrTmp[i].indexOf('=');
        var paraName = arrTmp[i].substr(0, dIntPos);
        var paraData = arrTmp[i].substr(dIntPos + 1);
        if (paraName.toUpperCase() === strName.toUpperCase()) {
            return paraData;
        }
    }
    return '';
};
export const echartsConfig = {
    minNumber: 10,
    minPercent: 0.05
};
export const randomLetNum = (length) => {
	var chars = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
     var res = '';
     for (var i = 0; i < length; i++) {
         var id = Math.ceil(Math.random() * 35);
         res += chars[id];
     }
     return res;
};
export const randomNumber = (length) => {
    return Math.floor((Math.random() + Math.floor(Math.random() * 9 + 1)) * Math.pow(10, length - 1));
};
export function currHost() {
    return location.href.match(/([^\/]*\/\/[^\/]*)\//)[1];
}


export function formatTime2(dateTimeStamp){   //dateTimeStamp是一个时间毫秒，注意时间戳是秒的形式，在这个毫秒的基础上除以1000，就是十位数的时间戳。13位数的都是时间毫秒。
    var minute = 1000 * 60;      //把分，时，天，周，半个月，一个月用毫秒表示
    var hour = minute * 60;
    var day = hour * 24;
    var week = day * 7;
    var halfamonth = day * 15;
    var month = day * 30;
    var now = new Date().getTime();   //获取当前时间毫秒
//  console.log(now)
    var diffValue = now - dateTimeStamp;//时间差

    if(diffValue < 0){
        return;
    }
    var minC = diffValue/minute;  //计算时间差的分，时，天，周，月
    var hourC = diffValue/hour;
    var dayC = diffValue/day;
    var weekC = diffValue/week;
    var monthC = diffValue/month;
    let result = "";
    if(monthC >= 1 && monthC <= 3){
        result = " " + parseInt(monthC) + "月前"
    }else if(weekC >= 1 && weekC <= 3){
        result = " " + parseInt(weekC) + "周前"
    }else if(dayC >= 1 && dayC <= 7){
        result = " " + parseInt(dayC) + "天前"
    }else if(hourC >= 1 && hourC <= 24){
        result = " " + parseInt(hourC) + "小时前"
    }else if(minC >= 1 && minC <= 60){
        result =" " + parseInt(minC) + "分钟前"
    }else if(diffValue >= 0 && diffValue <= minute){
        result = "刚刚"
    }else {
        var datetime = new Date();
        datetime.setTime(dateTimeStamp);
        var Nyear = datetime.getFullYear();
        var Nmonth = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
        var Ndate = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
        var Nhour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
        var Nminute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
        var Nsecond = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
        result = Nyear + "-" + Nmonth + "-" + Ndate
    }
    return result;
}



// WEBPACK FOOTER //
// ./src/utils/utils.js